import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { PROGRESS_BAR_SIZES, DEFAULT_PROGRESS_BAR_SIZE, DEFAULT_PROGRESS_BAR_COLOR_VARIANT } from '../../constants.js';
import { getResponsiveSx, getStartingSize } from '../../utils/styleHelpers.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { keyframes } from '@emotion/react';
import { B as Body } from '../Body/Body.js';
import { _ as _taggedTemplateLiteral } from '../../unsorted/taggedTemplateLiteral.js';
import { R as RollingText } from '../RollingText/RollingText.js';
import { S as Stack } from '../Stack/Stack.js';
import { B as Box } from '../Box/Box.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { useTheme } from '../../hooks/useTheme.js';
import { useGetCurrentSizeClass } from '../../hooks/useGetCurrentSizeClass.js';
import { useGetSubcomponentChild } from '../../hooks/useGetSubcompnentChild.js';

var _excluded$2 = ["size", "className", "children", "sx", "centerText"];
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProgressBarCaption(_ref) {
  var size = _ref.size,
    className = _ref.className,
    children = _ref.children,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$centerText = _ref.centerText,
    centerText = _ref$centerText === void 0 ? false : _ref$centerText,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var mergedSx = useMemo(function () {
    return merge(_objectSpread$3({}, centerText ? {
      textAlign: "center",
      order: -1
    } : {
      textAlign: "right",
      ml: "auto"
    }), sx);
  }, [sx, centerText]);
  return jsx(Body, _objectSpread$3(_objectSpread$3({}, props), {}, {
    size: size !== null && size !== void 0 ? size : "small",
    sx: mergedSx,
    className: "".concat(className !== null && className !== void 0 ? className : "", " ProgressBarCaption"),
    children: children
  }));
}
ProgressBarCaption.displayName = "ProgressBar.Caption";

var _templateObject;
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getContainerColorVariantSx(variant) {
  switch (variant) {
    case "brand":
      return {
        "& .barContainer__bar": {
          bg: "base.color.brand.1"
        }
      };
    case "gradient":
      return {
        "& .barContainer__bar": {
          bg: "base.gradient.1"
        }
      };
    case "inverted":
      return {
        "& .barContainer__bar": {
          bg: "base.color.translucent.inverse.1000"
        },
        "& .ProgressBarCaption, & .ProgressBarLabel .RollingText__textContainer": {
          c: "base.color.text.body.inverse.primary"
        }
      };
    case "guidance":
    default:
      return {
        "& .barContainer__bar": {
          bg: "base.color.status.guidance.bright"
        }
      };
  }
}
var barContainerBaseSx = {
  overflow: "hidden",
  brad: "base.borderRadius.x4",
  minw: "100px"
};
function getBarContainerSx(_ref) {
  var size = _ref.size,
    base = _ref.theme.base;
  switch (size) {
    case "small":
      return {
        height: base.spacing.x1
      };
    case "medium":
    default:
      return {
        height: base.spacing.x2
      };
  }
}
var getResponsiveBarContainerSx = function getResponsiveBarContainerSx(props) {
  return getResponsiveSx(_objectSpread$2(_objectSpread$2({}, props), {}, {
    renderSxAtSize: getBarContainerSx
  }));
};
var baseBarSx = {
  h: "100%"
};
var wipeMask = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    translate: -95% 0;\n  }\n  100% {\n    translate: 97% 0;\n  }\n"])));
function getVariantBasedBarSx(_ref2) {
  var motionProfile = _ref2.motionProfile,
    variant = _ref2.variant,
    disableBarTransition = _ref2.disableBarTransition,
    value = _ref2.value;
  switch (variant) {
    case "determinate":
      return _objectSpread$2({
        w: "".concat(value, "%")
      }, !disableBarTransition || motionProfile !== "none" ? {
        transitionProperty: "width",
        transitionDuration: "base.motion.normal.".concat(motionProfile, ".cssDuration"),
        transitionTimingFunction: "base.motion.normal.".concat(motionProfile, ".cssEase")
      } : {});
    case "indeterminate":
    default:
      return {
        WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 50%, transparent 100%)",
        animation: "".concat(wipeMask, " ").concat(motionProfile === "gentle" ? "1.7s" : "0.8s", " infinite"),
        animationTimingFunction: "linear"
      };
  }
}
var leftRollingTextBaseSx = {
  minw: "50%"
};

var _excluded$1 = ["className", "text", "rc", "use", "sx", "centerText", "testId"],
  _excluded2$1 = ["size"],
  _excluded3 = ["weight"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProgressBarLabel(_ref) {
  var className = _ref.className,
    text = _ref.text,
    rc = _ref.rc,
    use = _ref.use,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$centerText = _ref.centerText,
    centerText = _ref$centerText === void 0 ? false : _ref$centerText,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var _ref2 = "size" in props ? props : _objectSpread$1({
      size: "small"
    }, props),
    size = _ref2.size,
    propsMinusSize = _objectWithoutProperties(_ref2, _excluded2$1);
  var _ref3 = "weight" in propsMinusSize ? propsMinusSize : _objectSpread$1(_objectSpread$1({}, propsMinusSize), {}, {
      weight: "regular"
    }),
    weight = _ref3.weight,
    propsMinusSizeWeight = _objectWithoutProperties(_ref3, _excluded3);
  var mergedSx = useMemo(function () {
    return merge(leftRollingTextBaseSx, _objectSpread$1({
      w: "auto"
    }, centerText ? {
      "& .RollingText__textContainer": {
        justifyContent: "center"
      }
    } : {
      "& .RollingText__textContainer": {
        justifyContent: "flex-start"
      }
    }), sx);
  }, [sx, centerText]);
  return jsx(RollingText, _objectSpread$1(_objectSpread$1({}, propsMinusSizeWeight), {}, {
    rc: rc,
    use: use,
    size: size,
    weight: weight,
    text: text,
    sx: mergedSx,
    className: "".concat(className !== null && className !== void 0 ? className : "", " ProgressBarLabel"),
    testId: testId
  }));
}
ProgressBarLabel.displayName = "ProgressBar.Label";

var _excluded = ["children", "size", "variant", "colorVariant", "sx", "className", "testId", "motionProfile", "centerText", "disableBarTransition", "hideText"],
  _excluded2 = ["value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProgressBar(_ref) {
  var _ref2;
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? DEFAULT_PROGRESS_BAR_SIZE : _ref$size,
    variant = _ref.variant,
    _ref$colorVariant = _ref.colorVariant,
    colorVariant = _ref$colorVariant === void 0 ? DEFAULT_PROGRESS_BAR_COLOR_VARIANT : _ref$colorVariant,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    className = _ref.className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "ProgressBar" : _ref$testId,
    motionProfile = _ref.motionProfile,
    _ref$centerText = _ref.centerText,
    centerText = _ref$centerText === void 0 ? false : _ref$centerText,
    _ref$disableBarTransi = _ref.disableBarTransition,
    disableBarTransition = _ref$disableBarTransi === void 0 ? false : _ref$disableBarTransi,
    _ref$hideText = _ref.hideText,
    hideText = _ref$hideText === void 0 ? false : _ref$hideText,
    props = _objectWithoutProperties(_ref, _excluded);
  var isDeterminant = useMemo(function () {
    return variant === "determinate";
  }, [variant]);
  var _useTheme = useTheme(),
    globalConfig = _useTheme.globalConfig;
  var motionProfileToUse = (_ref2 = motionProfile !== null && motionProfile !== void 0 ? motionProfile : globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.motionProfile) !== null && _ref2 !== void 0 ? _ref2 : "gentle";
  var _ref3 = isDeterminant ? props : _objectSpread(_objectSpread({}, props), {}, {
      value: undefined
    }),
    value = _ref3.value,
    otherProps = _objectWithoutProperties(_ref3, _excluded2);
  var theme = useTheme();
  var startingSize = getStartingSize(size, DEFAULT_PROGRESS_BAR_SIZE, PROGRESS_BAR_SIZES);
  var allBarContainerSx = merge(barContainerBaseSx, getBarContainerSx({
    theme: theme,
    size: startingSize
  }), getResponsiveBarContainerSx({
    theme: theme,
    size: size
  }));
  var sizeClass = useGetCurrentSizeClass(size, DEFAULT_PROGRESS_BAR_SIZE, PROGRESS_BAR_SIZES);
  var label = useGetSubcomponentChild(children, ProgressBarLabel);
  var caption = useGetSubcomponentChild(children, ProgressBarCaption);
  var allBarSx = merge(baseBarSx, getVariantBasedBarSx({
    variant: variant,
    value: value,
    disableBarTransition: disableBarTransition,
    motionProfile: motionProfileToUse
  }));
  var allContainerSx = merge({
    w: "100%"
  }, getContainerColorVariantSx(colorVariant), sx);
  var shouldRenderGap = !label && isDeterminant || label || caption || !caption && isDeterminant;
  return jsxs(Stack, _objectSpread(_objectSpread({}, otherProps), {}, {
    className: "".concat(className !== null && className !== void 0 ? className : "", " ProgressBar ProgressBar--").concat(sizeClass, " ProgresBar--").concat(variant, " ").concat(centerText ? "ProgressBar--centerText" : ""),
    sx: allContainerSx,
    gap: shouldRenderGap ? "base.spacing.x2" : "0px",
    testId: testId,
    children: [jsx(Box, {
      sx: allBarContainerSx,
      testId: "".concat(testId, "__barContainer"),
      className: "barContainer",
      children: jsx(Box, {
        sx: allBarSx,
        testId: "".concat(testId, "__barContainer__bar"),
        className: "barContainer__bar"
      })
    }), !hideText && jsxs(Stack, {
      direction: centerText ? "column" : "row",
      alignItems: "center",
      className: "textContainer",
      testId: "".concat(testId, "__textContainer"),
      children: [!label && isDeterminant ? jsx(ProgressBarLabel, {
        text: "".concat(value, "%"),
        testId: "".concat(testId, "__label"),
        centerText: centerText
      }) : label ? jsx(SmartClone, {
        testId: "".concat(testId, "__label"),
        centerText: centerText,
        children: label
      }) : null, !caption && isDeterminant ? jsx(ProgressBarCaption, {
        testId: "".concat(testId, "__caption"),
        centerText: centerText,
        children: "100%"
      }) : caption ? jsx(SmartClone, {
        testId: "".concat(testId, "__caption"),
        centerText: centerText,
        children: caption
      }) : null]
    })]
  }));
}
ProgressBar.displayName = "ProgressBar";
ProgressBar.Label = ProgressBarLabel;
ProgressBar.Caption = ProgressBarCaption;

export { ProgressBar as P };
//# sourceMappingURL=ProgressBar.js.map
